import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-config-help-card',
  templateUrl: './catalogs-config-help-card.component.html',
  styleUrls: ['./catalogs-config-help-card.component.scss']
})
export class CatalogsConfigHelpCardComponent implements OnInit, OnChanges {

  @Input() assistantActive;
  updatecatalogsConfigHelpSubscription: Subscription;

  basicDataForm = new FormGroup({
    help: new FormControl(null, Validators.required)
  });

  constructor(private mcatalogConfigService: McatalogConfigService,
              private snackbarService: SnackBarService) {}

  ngOnInit() {}

  ngOnChanges() {
    if ((this.assistantActive === true) || (this.assistantActive === false)) {
      this.resetForm();
    }
  }

  public submitForm(e) {
    this.updatecatalogsConfigHelpSubscription = this.mcatalogConfigService.updateCatalogsConfigHelp(this.basicDataForm.get('help').value).pipe(
      tap(o => this.mcatalogConfigService.refreshMCatalogConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.mcatalogConfigService.refreshMCatalogConfig();
        return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      help: this.assistantActive
    });
  }

}
